import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  TrashIcon,
  EyeIcon,
  DragIcon,
} from "../../components/SVGIcon";

const SortablePhoto = ({ id, disabled, imageURL, onDelete, isEdited, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({ id, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      className={`${isEdited ? "report-photo-box" : ""}`}
      style={style}
      {...attributes}
    >
      {children}

      {!disabled && (
        <div
          data-id={id}
          className="report-photo-buttons"
        >
          <EyeIcon size={48} className="cursor-pointer text-white" />
          {/* <DragIcon size={48} className="cursor-pointer text-white" /> */}
          <span
            ref={setActivatorNodeRef}
            {...(!disabled ? listeners : {})}
            className="drag-handle"
          >
            <DragIcon size={48} className="cursor-pointer text-white" />
          </span>
          <span
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete?.();
            }}
            className="drag-handle"
          >
            <TrashIcon size={48} className="cursor-pointer text-white" />
          </span>
        </div>
      )}
    </div>
  );
};

export default SortablePhoto;
